export default __webpack_public_path__ + "static/media/sm6.c3c7c4d0.png";